import { NOT_AVAILABLE } from "~/common/constants";
import { PRONOUNS } from "~/patients/constants/constants";
import { RELATIONSHIPS } from "~/patients/constants/relationships";
import {
  pronounOptionsSchema,
  relationshipOptionsSchema,
} from "~/patients/schemas/account";
import { getFormatNumber } from "./GetFormatNumber";
import { PatientData } from "./types";

export const getPatientInfoDefaultValues = (patient: PatientData) => {
  const emergencyContacts = patient.organization_patients[0].emergency_contacts;
  return {
    patientId: patient.id,
    name: patient.name,
    lastName: patient.last_name,
    pronouns: getDefaultPronouns(patient),
    dateOfBirth: patient.birthday,
    mobileNumber: patient.phone_number
      ? getFormatNumber(patient.phone_number.number)
      : "",
    email: patient.email,
    streetAddress: patient.addresses[0]?.street ?? NOT_AVAILABLE,
    apartment: patient.addresses[0]?.apartment ?? NOT_AVAILABLE,
    city: patient.addresses[0]?.city ?? NOT_AVAILABLE,
    state: patient.addresses[0]?.state ?? NOT_AVAILABLE,
    zipCode: patient.addresses[0]?.zipcode ?? NOT_AVAILABLE,
    emergencyContactFirstName: emergencyContacts[0]?.name ?? NOT_AVAILABLE,
    emergencyContactLastName: emergencyContacts[0]?.last_name ?? NOT_AVAILABLE,
    emergencyContactRelationship: getDefaultRelationship(patient).relationship,
    emergencyCustomRelationship:
      getDefaultRelationship(patient).customRelationship,
    emergencyContactMobileNumber:
      emergencyContacts.length > 0
        ? getFormatNumber(emergencyContacts[0]?.phone_number)
        : "",
    emergencyContactEmail:
      patient.organization_patients[0].emergency_contacts[0]?.email,
  };
};

const getDefaultPronouns = (patient: PatientData) => {
  const stringPronouns = patient.pronouns
    ? Object.values(patient.pronouns).join("/")
    : NOT_AVAILABLE;
  const hasCustomPronouns =
    !pronounOptionsSchema.safeParse(stringPronouns).success;

  return {
    pronouns: hasCustomPronouns ? PRONOUNS.other : stringPronouns,
    customPronouns: hasCustomPronouns ? stringPronouns : NOT_AVAILABLE,
  };
};

const getDefaultRelationship = (patient: PatientData) => {
  const relationship =
    patient.organization_patients[0].emergency_contacts[0]?.relationship;
  const hasCustomRelationship =
    !relationshipOptionsSchema.safeParse(relationship).success;

  return {
    relationship: hasCustomRelationship ? RELATIONSHIPS.OTHER : relationship,
    customRelationship: hasCustomRelationship ? relationship : NOT_AVAILABLE,
  };
};
